var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 20.4181C4.44654 17.4316 6.61915 15.7369 8.5178 15.3341C10.4165 14.9312 12.2241 14.8704 13.9409 15.1515V20.5L22 11.7726L13.9409 3.5V8.5835C10.7667 8.6086 8.0681 9.7474 5.84525 12C3.62237 14.2526 2.34063 17.0586 2 20.4181Z",
    fill: "#1C1B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6584 2.80525C13.9411 2.69033 14.2652 2.75811 14.4781 2.97667L22.5372 11.2493C22.8155 11.535 22.8216 11.9885 22.551 12.2815L14.4919 21.0088C14.2824 21.2357 13.9553 21.311 13.6678 21.1985C13.3802 21.086 13.1909 20.8088 13.1909 20.5V15.8054C11.7619 15.6469 10.2574 15.7317 8.67349 16.0678C7.04152 16.4141 5.009 17.9286 2.5802 20.8934C2.37052 21.1493 2.01788 21.2376 1.71232 21.1107C1.40676 20.9838 1.22047 20.6716 1.25385 20.3424C1.61049 16.825 2.96003 13.8561 5.31143 11.4732L5.84527 12L5.31143 11.4732C7.49859 9.2568 10.1363 8.0479 13.1909 7.85925V3.50002C13.1909 3.19489 13.3758 2.92018 13.6584 2.80525ZM14.6909 5.3447V8.58352C14.6909 8.99542 14.3587 9.33024 13.9469 9.3335C10.9705 9.35704 8.462 10.4161 6.37912 12.5268L5.89229 12.0464L6.37911 12.5268C4.87776 14.0483 3.82883 15.8373 3.23562 17.9078C5.02867 16.0875 6.73693 14.9453 8.36216 14.6005C10.3414 14.1805 12.2434 14.1136 14.0621 14.4114C14.4247 14.4708 14.6909 14.7841 14.6909 15.1515V18.5823L20.9664 11.7865L14.6909 5.3447Z",
    fill: "#1C1B1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.f52472cd.svg";
export { ForwardRef as ReactComponent };